import { Box, Group, Text, ActionIcon, Paper } from "@mantine/core";
import { IconDots, IconArrowsMaximize } from "@tabler/icons-react";
import CollaborationChatTab from "../../CollaborationChatTab";

type Props = {
  matchId: string;
  chatOpen: boolean;
  collaborationReadOnly?: boolean;
  currentUserId: string | undefined;
  previewLocked?: boolean;
  onExpand?: () => void;
  /** When true, the chat is rendered inside a Drawer; suppress the internal header/border to avoid a double-header. */
  hideHeader?: boolean;
};

export default function AssessmentChatSidebar({
  matchId,
  chatOpen,
  collaborationReadOnly,
  currentUserId,
  previewLocked,
  onExpand,
  hideHeader = false,
}: Props) {
  return (
    <Paper
      withBorder={!hideHeader}
      radius={hideHeader ? 0 : "md"}
      p={0}
      style={{
        backgroundColor: "#ffffff",
        borderColor: "var(--mantine-color-slate-2)",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        flex: 1,
        overflow: "hidden",
        border: hideHeader ? "none" : undefined,
        boxShadow: hideHeader ? "none" : undefined,
      }}
    >
      {!hideHeader && (
        <Group
          justify="space-between"
          align="center"
          wrap="nowrap"
          px="md"
          py="sm"
          style={{ borderBottom: "1px solid var(--mantine-color-slate-2)", flexShrink: 0 }}
        >
          <Group gap="xs" align="center" wrap="nowrap">
            <Text fw={700} fz="sm" c="dark.6">
              Collaboration Chat
            </Text>
            <Group gap={4} align="center" wrap="nowrap">
              <Box
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: chatOpen && !previewLocked ? "var(--mantine-color-green-6)" : "var(--mantine-color-slate-4)",
                }}
              />
              <Text fz={11} c={chatOpen && !previewLocked ? "green.7" : "slate.5"} fw={500}>
                {chatOpen && !previewLocked ? "Online" : "Locked"}
              </Text>
            </Group>
          </Group>
          <Group gap={4} wrap="nowrap">
            {onExpand && (
              <ActionIcon variant="subtle" color="gray" size="sm" onClick={onExpand} aria-label="Expand chat">
                <IconArrowsMaximize size={16} />
              </ActionIcon>
            )}
            <ActionIcon variant="subtle" color="gray" size="sm" aria-label="More options" disabled>
              <IconDots size={16} />
            </ActionIcon>
          </Group>
        </Group>
      )}
      <Box
        px="sm"
        py="sm"
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <CollaborationChatTab
          matchId={matchId}
          chatOpen={chatOpen}
          collaborationReadOnly={collaborationReadOnly}
          currentUserId={currentUserId}
          previewLocked={previewLocked}
        />
      </Box>
    </Paper>
  );
}
